<template>
<el-tag
    :type="status === 1 ? 'success' : 'danger'"
    :class="{ active: status === 1, inactive: status === 0 }"
    size="small"
  >
    {{ statusText }}
</el-tag>
</template>
<script>
export default {
  name: "StatusGeneral",
  props: {
    status: {
      type: Number,
      required: true,
      validator: (value) => [0, 1].includes(value), // Garante que o valor é 0 ou 1
    },
  },
  computed: {
    statusText() {
      return this.status === 1 ? "Ativo" : "Inativo";
    },
  },
};
</script>

<style scoped>
.active {
  background-color: #e8f5e9; /* Verde claro */
  color: #2e7d32; /* Verde escuro */
  border-color: #2e7d32;
}
.inactive {
  background-color: #ffebee; /* Vermelho claro */
  color: #c62828; /* Vermelho escuro */
  border-color: #c62828;
}
</style>